import { render, staticRenderFns } from "./Academy_HH.vue?vue&type=template&id=66e6a3b6"
import script from "./Academy_HH.vue?vue&type=script&lang=js"
export * from "./Academy_HH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports